module.exports = __webpack_public_path__ + "static/media/btn_iniciar_transparente.cddd271d.svg";